import { reportToSentry } from 'utils/reportToSentry'
import { getAuthHeader } from '../../../../utils/auth/helpers'
import { addMagentoEnvAuthHeaders } from '../../../../utils/magentoEnvAuthHeaders'

async function submitFinalizeInvoice(
  patientHash: string
) {

  try {
    const response = await finalizeInvoiceApi( patientHash )

    if ( response?.meta?.toLowerCase() === `ok` )
      return {
        status: `success`,
        message: `Submitted successfully.`
      }

    reportToSentry( new Error( `Error submitting finalize invoice` ), {
      patientHash,
      response: JSON.stringify( response )
    })

    return {
      status: `error`,
      message: `Error submitting finalize invoice. Please try again.`
    }
  } catch ( e ) {
    reportToSentry( new Error( `Error submitting finalize invoice` ), {
      patientHash
    })
    return {
      status: `error`,
      message: `Error submitting finalize invoice. Please try again.`
    }
  }
}

export const finalizeInvoiceApi = async ( patientHash: string ) => {
  const response = await fetch( `${process.env.REACT_APP_AOB_URL}/invoice/${patientHash}/done`, {
    method: `POST`,
    headers: {
      'Content-Type': `application/json`,
      'Authorization': getAuthHeader(),
      ...addMagentoEnvAuthHeaders()
    }
  })

  return await response.json()
}

export default submitFinalizeInvoice
